var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yunyouhuaijiu_PC",on:{"click":_vm.download}},[_c('img',{attrs:{"src":"/static/img/yunyouhuaijiu/pc_bg.jpg","alt":""},on:{"click":_vm.download}})])}
var staticRenderFns = []

export { render, staticRenderFns }